import script from "./activity.vue?vue&type=script&lang=ts&setup=true"
export * from "./activity.vue?vue&type=script&lang=ts&setup=true"

import "./activity.vue?vue&type=style&index=0&id=ce508ba0&lang=scss"

const __exports__ = script;

export default __exports__